import { render, staticRenderFns } from "./FaqAdd.vue?vue&type=template&id=3b48de1f&scoped=true&"
import script from "./FaqAdd.vue?vue&type=script&lang=js&"
export * from "./FaqAdd.vue?vue&type=script&lang=js&"
import style0 from "./FaqAdd.vue?vue&type=style&index=0&id=3b48de1f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b48de1f",
  null
  
)

export default component.exports